import React, {Component} from 'react';
import Logger from "../helpers/Logger";
import MiniLoader from "./MiniLoader";

export default class MiniLoaderContainer extends Component {
    componentDidCatch(error, info) {
        const logger = new Logger(this.props.logPath);
        logger.critical('REACT: error caught in MiniLoaderContainer', error.toString());
    }

    render() {
        return (<MiniLoader dataParameters={this.props.parameters} translations={this.props.translations}/>);
    }
}



// WEBPACK FOOTER //
// ./src/components/MiniLoaderContainer.js